import { inject, Injectable } from '@angular/core';
import { consumerPollProducersForChange } from '@angular/core/primitives/signals';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root',
})
export class LanguageService {
    private defaultLang = 'fr';
    private supportedLangs = ['en', 'fr'];
    private supportedLangList = [
        { code: 'EN', label: 'English', emoji: '🇬🇧' },
        { code: 'FR', label: 'Français', emoji: '🇫🇷' },
        // { code: 'ES', label: 'Español', emoji: '🇪🇸' },
    ];
    private translate = inject(TranslateService);

    constructor() {
        this.initLanguage();
    }

    initLanguage(): void {
        const savedLang = sessionStorage.getItem('appLang');
        const browserLang = this.translate.getBrowserLang();
        const initialLang =
            savedLang && this.supportedLangs.includes(savedLang)
                ? savedLang
                : browserLang?.match(/en|fr/)?.[0] ?? this.defaultLang;

        this.setLanguage(initialLang);
    }

    setLanguage(lang: string): void {
        if (!this.supportedLangs.includes(lang.toLowerCase())) return;

        this.translate.use(lang.toLowerCase());
        sessionStorage.setItem('appLang', lang);
    }

    getCurrentLang(): string {
        return this.translate.getCurrentLang() || this.defaultLang;
    }

    getSupportedLangs(): string[] {
        return this.supportedLangs;
    }

    getsupportedLangList() {
        return this.supportedLangList;
    }
}
